<!--
  Replacement for nameWithTitleDirective.js
  <dt-name-with-title></dt-name-with-title>
-->
<template>
    <span class="user-selectable">{{ name }}</span>
</template>

<script>
import { container } from '@/container';

export default {
    props: {
        /**
         * @type {Contact}
         */
        contact: {
            type: Object,
            required: true,
        },
    },

    computed: {
        shouldShowTitle() {
            return container.userService.company.shouldCaptureTitles() && this.contact.title;
        },

        name() {
            return (this.shouldShowTitle ? this.contact.title : '')
                + `${this.contact.firstName} ${this.contact.lastName}`;
        },
    },
};
</script>
